import { render, staticRenderFns } from "./ProvvigioniSettoriForm.vue?vue&type=template&id=0d3094ba&scoped=true"
import script from "./ProvvigioniSettoriForm.vue?vue&type=script&lang=js"
export * from "./ProvvigioniSettoriForm.vue?vue&type=script&lang=js"
import style0 from "./ProvvigioniSettoriForm.vue?vue&type=style&index=0&id=0d3094ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3094ba",
  null
  
)

export default component.exports